import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import FlightReportLegDelayJustifications from './FlightReportLegDelayJustifications';

class FlightReportLegDelaysTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      flight_report_id: this.props.flight_report_id,
      flight_report_leg_delays: this.props.flight_report_leg_delays,
      flight_report_leg_delay_justifications: this.props.flight_report_leg_delay_justifications,
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      flight_report_leg_delay_edit: {},
    };

    //bind específico
    this.delete = this.delete.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.refreshJustificationsModal = this.refreshJustificationsModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.fuel_type === 'undefined' || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        flight_report_id: newProps.flight_report_id,
        flight_report_leg_delays: newProps.flight_report_leg_delays,
        flight_ptbr_selects: newProps.flight_ptbr_selects,
        flight_omni_selects: newProps.flight_omni_selects,
        ptbr_departure_selects: newProps.ptbr_departure_selects,
        omni_departure_selects: newProps.omni_departure_selects,
        ptbr_flight_selects: newProps.ptbr_flight_selects,
        omni_flight_selects: newProps.omni_flight_selects,
        loaded: 1,
      });
    }
  }

  delete (id) {
    if (window.confirm('Tem certeza que deseja excluir esse atraso?')) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/atraso', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  openEditModal (id) {
    var self = this;
    Object.keys(this.state.flight_report_leg_delays).map(function(k) {
      if(self.state.flight_report_leg_delays[k].id == id) {
        self.setState({
          modal: true,
          flight_report_leg_delay_edit: self.state.flight_report_leg_delays[k],
          flight_report_leg_delay_justifications: self.state.flight_report_leg_delays[k].flight_report_leg_delay_justifications,
        });
      }
    });
  }

  closeModal(responseJson) {
    this.props.handleAlert('', '', 'open');
    this.setState({
      modal: false,
      flight_report_leg_delay_edit: {},
      flight_report_leg_delay_justifications: {},
    }, this.props.updateData({message: 'Dados atualizados com sucesso', status: 'success', data: {}}));
  }


  refreshJustificationsModal(responseJson) {
    this.setState({
      flight_report_leg_delay_justifications: responseJson.data,
    });
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Atrasos</h3>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>Trecho</th>
          <th>Tipo</th>
          <th>Atraso total</th>
          <th className="col-md-1 text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_leg_delays).map(function(k) {
        var srld = self.state.flight_report_leg_delays[k];
        return (
          <tr>
            <td>{srld.flight_report_leg.leg_number}</td>
            <td>{srld.type_str}</td>
            <td>{srld.total_delay_time}</td>
            <td className="text-center">
              <button onClick={() => self.delete(srld.id)} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
              <button onClick={() => self.openEditModal(srld.id)} className="btn btn-primary btn-sm"><i className="fa fa-pencil"></i></button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Justificativas</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <FlightReportLegDelayJustifications updateData={this.props.updateData} updated={this.props.updated} handleAlert={this.props.handleAlert} flight_ptbr_selects={this.props.flight_ptbr_selects} flight_omni_selects={this.props.flight_omni_selects} codes_ptbr_select={this.props.codes_ptbr_select} flight_report_leg_delay_edit={this.state.flight_report_leg_delay_edit} flight_report_leg_delay_justifications={this.state.flight_report_leg_delay_justifications} refreshJustificationsModal={this.refreshJustificationsModal} ptbr_departure_selects={this.state.ptbr_departure_selects} ptbr_flight_selects={this.state.ptbr_flight_selects} omni_departure_selects={this.state.omni_departure_selects} omni_flight_selects={this.state.omni_flight_selects} />
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportLegDelaysTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportLegDelaysTab.js